// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import LineHeightOutlinedSvg from "@ant-design/icons-svg/es/asn/LineHeightOutlined";
import AntdIcon from '../components/AntdIcon';

var LineHeightOutlined = function LineHeightOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: LineHeightOutlinedSvg
  }));
};

LineHeightOutlined.displayName = 'LineHeightOutlined';
export default React.forwardRef(LineHeightOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/LineHeightOutlined.js
// module id = 1417
// module chunks = 0